import request from '@/router/axios'

const API = '/api/produce/kanban/in-out-park-statistics'

function unwrap(res) {
  const body = res && res.data
  if (body && Object.prototype.hasOwnProperty.call(body, 'data')) return body.data
  return body
}

export function fetchInOutParkStatisticsPage(data = {}) {
  return request({
    url: `${API}/page`,
    method: 'post',
    data
  }).then(unwrap)
}

export function exportInOutParkStatistics(data = {}) {
  return request({
    url: `${API}/export`,
    method: 'post',
    data,
    responseType: 'blob'
  })
}

export function fetchCustomerOptions(params = {}) {
  return request({
    url: '/api/produce/blade-dept/select/distinct/select',
    method: 'get',
    params
  }).then(unwrap)
}
